import { TBodyMessage } from '../../../types/TxCosmosApi';
import { Table, TableBody } from '@mui/material';
import { Row, SectionWrapper } from '../../../components/tableComponents';
import TxMessageData from './TxMessageData';

type props = {
    message: TBodyMessage
}
  
const TxMessage = ({message}: props) => {  

    if(message["@type"] !== "/omnistar.omnistar.MsgCreateData"){
        return <SectionWrapper mb={3}>
            <>
                <Table  aria-label="overview snapshot table">
                    <TableBody>
                        <Row field='@type' value={`${message['@type']}`}/>
                    </TableBody>
                </Table>
                <TxMessageData data={JSON.stringify(message)}/>                
            </>
        </SectionWrapper>
    }
    
  
    return (
        <SectionWrapper mb={3}>
            <>
                <Table  aria-label="overview snapshot table">
                    <TableBody>
                        <Row field='@type' value={`${message['@type']}`}/>
                        <Row field='Creator' value={message.creator} hasCopyOption route={`/snapshots/${message.creator}`}/>
                        <Row field='Destination' value={message.destination} hasCopyOption route={`/snapshots/${message.destination}`}/>
                    </TableBody>
                </Table>
                <TxMessageData data={message.data}/>                
            </>
        </SectionWrapper>
    )
}
  
export default TxMessage;